import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import {
  EInvoice_EwayRegistration_add,
  EInvoice_EwayRegistration_update,
  EInvoice_EwayRegistration_delete,
  fetchEinvoiceEwaySetupRegistration,
  fetchEInvoiceEWaySetupMainData,
  fetchEInvoiceEwayRegistrationDtl,
  EInvoice_EwayRegistrationDtl_Add,
  EInvoice_EwayRegistrationDtl_Delete
} from "../../Redux/Einvoice&EwayBillSlice/Einvoice&EwayBill";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import Loader from "../../Components/Loader/Loader";
import Cookies from "js-cookie";

const Einvoice_Eway_Setup_Registration = () => {
  const dispatch = useDispatch();

  const {
    EInvoiceEwayRegisterData,
    EInvoiceEwayRegisterLoading,
    EInvoiceEWaySetupMainData,
    EInvoiceEwayRegisterDtlData,
    EInvoiceEwayRegisterDtlLoading
  } = useSelector((state) => state.EinvoiceEwayBill);

  const [activeView, setActiveView] = useState("Registration");

  // Modal State
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedDetailRow, setSelectedDetailRow] = useState(null);
  const [detailClientCount, setDetailClientCount] = useState("");

  const { AllClients } = useSelector((state) => state.Client);
  const loginData = Cookies.get("loginData");
  const AdminData = loginData ? JSON.parse(loginData) : null;

  const [formData, setFormData] = useState({
    ClientID: "",
    AdminID: AdminData?.data?._id || "",
    Provider: "",
    ClientCount: "",
  });

  useEffect(() => {
    dispatch(fetchEInvoiceEWaySetupMainData());
    dispatch(fetchAllClients());
    dispatch(fetchEinvoiceEwaySetupRegistration());
    dispatch(fetchEInvoiceEwayRegistrationDtl());
  }, [dispatch]);

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (formData) => {
    const errors = {};

    if (!formData.ClientID || formData.ClientID.trim() === "") {
      errors.ClientID = "Client is required";
    }

    if (!formData.Provider || formData.Provider.trim() === "") {
      errors.Provider = "Provider is required";
    }

    return errors;
  };

  const handleEdit = (row) => {
    setEditId(row?.RegisterId);
    setFormData({
      ClientID: row?.ClientID,
      AdminID: row?.AdminID || AdminData?.data?._id || "",
      Provider: row?.Provider,
      ClientCount: row?.ClientCount,
    });
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this registration?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(EInvoice_EwayRegistration_delete({ id: row.RegisterId })).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
      });
      dispatch(fetchEinvoiceEwaySetupRegistration());
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  const handleDetailDelete = async (row) => {

    const isConfirmed = window.confirm(
      `Are you sure you want to delete this detail?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(EInvoice_EwayRegistrationDtl_Delete(row?.MainID)).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
      });
      dispatch(fetchEInvoiceEwayRegistrationDtl());
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  const handleAddDetail = (row) => {
    setSelectedDetailRow(row);
    setDetailClientCount("");
    setDetailModalOpen(true);
  };

  const submitDetail = async () => {
    if (!detailClientCount) {
      toast.error("Client Count is required", { position: "top-right", autoClose: 1000 });
      return;
    }
    try {
      await dispatch(EInvoice_EwayRegistrationDtl_Add({
        id: selectedDetailRow.RegisterId,
        ClientCount: Number(detailClientCount)
      })).unwrap();
      toast.success("Detail added successfully!", { position: "top-right", autoClose: 1000 });
      setDetailModalOpen(false);
      dispatch(fetchEinvoiceEwaySetupRegistration());
      dispatch(fetchEInvoiceEwayRegistrationDtl());
    } catch (error) {
      toast.error(`Failed to add detail: ${error.message || "Unknown error"}`, { position: "top-right", autoClose: 1000 });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (editId) {
          await dispatch(EInvoice_EwayRegistration_update({ id: editId, formData })).unwrap();
          toast.success("Registration updated successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        } else {
          await dispatch(EInvoice_EwayRegistration_add({ values: formData, loginData: AdminData })).unwrap();
          toast.success("Registration added successfully!!", {
            position: "top-right",
            autoClose: 1000,
          });
        }

        // Reset form
        setFormData({
          ClientID: "",
          AdminID: AdminData?.data?._id || "",
          Provider: "",
          ClientCount: "",
        });
        setEditId(null);
        setErrors({});
        dispatch(fetchEinvoiceEwaySetupRegistration());
      } catch (error) {
        toast.error(
          `Failed to ${editId ? "update" : "add"} Data: ${error.message || "Unknown error"
          }`,
          {
            position: "top-right",
            autoClose: 1000,
          }
        );
      }
    }
  };

  const columns = [
    { field: "id", headerName: "No", minWidth: 50 },
    { field: "ClientName", headerName: "Client", minWidth: 150, flex: 1 },
    { field: "AdminID", headerName: "Admin Name", minWidth: 150, flex: 1 },
    { field: "ProviderName", headerName: "Provider", minWidth: 120, flex: 1 },
    { field: "ClientCount", headerName: "Client Count", minWidth: 120 },
    { field: "EINVAuthToken", headerName: "INVOICE Auth Token", minWidth: 180 },
    { field: "EINVTokenExpireDateTime", headerName: "INVOICE Created DateTime", minWidth: 200 },
    { field: "EINVSecretKey", headerName: "INVOICE Secret Key", minWidth: 180 },
    { field: "EWAYAuthToken", headerName: "EWAY Auth Token", minWidth: 180 },
    { field: "EWAYSecretKey", headerName: "EWAY Secret Key", minWidth: 180 },
    { field: "EWAYTokenExpireDateTime", headerName: "EWAY Created DateTime", minWidth: 200 },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 280,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
          <button
            className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
            onClick={() => handleAddDetail(params.row)}
          >
            Add Detail
          </button>
        </div >
      ),
    },
  ];

  const rows = Array?.isArray(EInvoiceEwayRegisterData) ? EInvoiceEwayRegisterData?.map((el, index) => ({
    id: index + 1,
    RegisterId: el._id,
    ClientID: el?.ClientID?._id || el?.ClientID,
    ClientName: el?.ClientID?.WhaClientName || "--",
    AdminID: typeof el?.AdminID === 'object' ? (el?.AdminID?.AdminName || el?.AdminID?._id) : el?.AdminID,
    Provider: el?.Provider?._id || el?.Provider,
    ProviderName: el?.Provider?.ProviderName || "--",
    ClientCount: el?.ClientCount,
    EINVAuthToken: typeof el?.ClientID === 'object' ? (el?.ClientID?.EINVAuthToken || "--") : "--",
    EINVTokenExpireDateTime: typeof el?.ClientID === 'object' ? (el?.ClientID?.EINVTokenExpireDateTime || "--") : "--",
    EINVSecretKey: typeof el?.ClientID === 'object' ? (el?.ClientID?.EINVSecretKey || "--") : "--",
    EWAYAuthToken: typeof el?.ClientID === 'object' ? (el?.ClientID?.EWAYAuthToken || "--") : "--",
    EWAYTokenExpireDateTime: typeof el?.ClientID === 'object' ? (el?.ClientID?.EWAYTokenExpireDateTime || "--") : "--",
    EWAYSecretKey: typeof el?.ClientID === 'object' ? (el?.ClientID?.EWAYSecretKey || "--") : "--",
  })) : [];

  const detailColumns = [
    { field: "id", headerName: "No", flex: 0.5 },
    { field: "ClientName", headerName: "Client", flex: 1 },
    { field: "ClientCount", headerName: "Client Count", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDetailDelete(params.row)}
          >
            Delete
          </button>
        </div >
      ),
    },
  ];

  const detailRows = Array?.isArray(EInvoiceEwayRegisterDtlData) ? EInvoiceEwayRegisterDtlData?.map((el, index) => ({
    id: index + 1,
    MainID: el?._id,
    ClientName: el?.EInvoiceEwayRegistration?.ClientID?.WhaClientName || "--",
    ClientCount: el?.ClientCount,
  })) : [];

  const ParentProviders = Array?.isArray(EInvoiceEWaySetupMainData) ? EInvoiceEWaySetupMainData : [];

  if (EInvoiceEwayRegisterLoading && !EInvoiceEwayRegisterData?.length) {
    return <Loader />;
  }

  const selectedClientData = AllClients?.data?.find(
    (client) => client._id === formData.ClientID
  );

  return (
    <div className="">
      <div className="title">
        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
          {editId ? "Update E-invoice & E-way Registration" : "Add E-invoice & E-way Registration"}
        </h3>
      </div>

      <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
        >
          {/* Client Dropdown */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">Client</h5>
            <select
              name="ClientID"
              value={formData.ClientID}
              onChange={handleChange}
              className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
            >
              <option value="">Select Client</option>
              {[...(AllClients?.data || [])]
                .sort((a, b) => {
                  const nameA = (a.FullName || a.name || a.CompanyName || a.WhaClientName || "").toLowerCase();
                  const nameB = (b.FullName || b.name || b.CompanyName || b.WhaClientName || "").toLowerCase();
                  return nameA.localeCompare(nameB);
                })
                .map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.FullName || client.name || client.CompanyName || client.WhaClientName} {client.MobileNo ? `- ${client.MobileNo}` : ''}
                  </option>
                ))}
            </select>
            {errors.ClientID && (
              <p className="text-red-500 text-sm mt-1">{errors.ClientID}</p>
            )}
          </div>

          {/* Admin ID Input */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">Admin Name</h5>
            <input
              type="text"
              placeholder="Enter Admin Name"
              value={AdminData?.data?.Name}
              className="bg-[#F3F8FB] w-full p-[6px] border-2 border-black rounded text-base"
              readOnly
            />
            {errors.AdminID && (
              <p className="text-red-500 text-sm mt-1">
                {errors.AdminID}
              </p>
            )}
          </div>

          {/* Provider Dropdown */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">Provider</h5>
            <select
              name="Provider"
              value={formData.Provider}
              onChange={handleChange}
              className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
            >
              <option value="">Select Provider</option>
              {[...ParentProviders]
                .sort((a, b) => (a.ProviderName || "").localeCompare(b.ProviderName || ""))
                .map((provider) => (
                  <option key={provider._id} value={provider._id}>
                    {provider.ProviderName}
                  </option>
                ))}
            </select>
            {errors.Provider && (
              <p className="text-red-500 text-sm mt-1">{errors.Provider}</p>
            )}
          </div>

          {/* Client Count Input */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <h5 className="my-2 block font-semibold">Client Count</h5>
            <input
              type="number"
              name="ClientCount"
              value={formData.ClientCount}
              onChange={handleChange}
              readOnly
              className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
            />
            {errors.ClientCount && (
              <p className="text-red-500 text-sm mt-1">{errors.ClientCount}</p>
            )}
          </div>

          {/* Submit Button */}
          <div className="submit_Form col-span-12 flex justify-center mt-3">
            <button type="submit" className="All_button">
              {editId ? "Update" : "Submit"}
            </button>

            {editId && (
              <button
                type="button"
                className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                onClick={() => {
                  setFormData({
                    ClientID: "",
                    AdminID: "",
                    Provider: "",
                    ClientCount: "",
                  });
                  setEditId(null);
                  setErrors({});
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="px-2 py-6">
        <div className="flex gap-3 mb-5">
          <button
            className={`px-4 py-2 font-semibold text-base rounded transition-all duration-300 ${activeView === 'Registration' ? 'bg-[#002f6c] text-white shadow-md' : 'bg-gray-300 text-gray-700 hover:bg-gray-400'}`}
            onClick={() => setActiveView('Registration')}
          >
            View E-invoice & E-way Registration
          </button>
          <button
            className={`px-4 py-2 font-semibold text-base rounded transition-all duration-300 ${activeView === 'Detail' ? 'bg-[#002f6c] text-white shadow-md' : 'bg-gray-300 text-gray-700 hover:bg-gray-400'}`}
            onClick={() => setActiveView('Detail')}
          >
            View E-invoice & E-way Registration Detail
          </button>
        </div>

        <div className="title">
          {/* <h3 className="text-lg font-bold main_title_page text-white px-3 py-2 inline-block text-uppercase rounded">
            {activeView === 'Registration' ? 'View E-invoice & E-way Registration' : 'View E-invoice & E-way Registration Detail'}
          </h3> */}
        </div>
        <div className="rounded-lg overflow-x-auto mt-3">
          {activeView === 'Registration' ? (
            <WpDynamicTable columns={columns} rows={rows} height="450px" />
          ) : (
            <WpDynamicTable columns={detailColumns} rows={detailRows} height="450px" />
          )}
        </div>
      </div>

      {/* Detail Modal */}
      {detailModalOpen && (
        <div className="fixed inset-0 min-h-screen bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-sm shadow-xl">
            <h3 className="text-xl font-bold mb-4">Add Detail</h3>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">Client Count</label>
              <input
                type="number"
                className="w-full p-2 border-2 border-gray-300 rounded"
                value={detailClientCount}
                onChange={(e) => setDetailClientCount(e.target.value)}
                placeholder="Enter Client Count"
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                onClick={() => setDetailModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                onClick={submitDetail}
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Einvoice_Eway_Setup_Registration;







